import { useMutation } from '@tanstack/react-query';
import { formatDate } from 'date-fns';
import { saveAs } from 'file-saver';
import toast from 'react-hot-toast';

import { ticketApi } from '../../api/lib/tickets';

import { dateFormats } from '@/constants/date-formats';
import { ApiError } from '@/types/interfaces/api-error';

export const useDownloadDiscountTickets = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: ({ from, to }: { from: Date; to: Date }) =>
      ticketApi.downloadDiscountedTickets(from, to),
    onSuccess: (data, { from, to }) => {
      const mimetype = 'application/xlsx';

      const url = 'data:' + mimetype + ';base64,' + data.content;

      saveAs(
        url,
        `Discounted-tickets-${formatDate(
          new Date(from ?? new Date()),
          `${dateFormats.day}.${dateFormats.month}.${dateFormats.yearShort}`,
        )}-${formatDate(
          new Date(to ?? new Date()),
          `${dateFormats.day}.${dateFormats.month}.${dateFormats.yearShort}`,
        )}.xlsx`,
      );

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
